import { getUser } from "./utils";

export const teamHasDialler = (checkUserKind = true, user = null) => {
  user = user || getUser();
  return (
    !(checkUserKind && user.kind === "viewer") &&
    ["standard", "unlimited"].includes(user.diallerPlan)
  );
};

/**
 * @param {any} user
 * @param { "ausConversations"
 *   | "euConversations"
 *   | "ukConversations"
 *   | "usConversations"
 *   | "data"
 *   | "dataRefresh"
 *   | "inboxAgent"
 *   | "outreach"
 *   | "notetaker"} kind
 */
export const hasLicense = (user, kind) =>
  !user.licenses || user.licenses.includes(kind);

export const conversationsLicenses = [
  "ausConversations",
  "euConversations",
  "ukConversations",
  "usConversations",
];

/**
 * @param {any} user
 */
export const hasConversationsLicense = (user) =>
  conversationsLicenses.some((kind) => hasLicense(user, kind));
